const mostRecent = (a, b) => {
  // Sort by most recent record, as there can be multiple records.
  // eg. [newestRecord, oldRecord, oldestRecord]
  if (a.createdAt > b.createdAt) {
    return -1;
  }
  else if (a.createdAt < b.createdAt) {
    return 1;
  }
  else {
    return 0;
  }
};

export const partnershipStatus = ({ partnerships, requesterId, requesteeId }) => {
  const partnership = partnerships.filter(p => {
    return (p.requesteeId === requesteeId) && (p.requesterId === requesterId);
  }).sort(mostRecent)[0];

  return (partnership && partnership.status) || null;
};
